<script>
export default {
    name: 'IconEyeVisible',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-eye-visible"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 16c8.837 0 16.837 5.333 24 16-7.163 10.667-15.163 16-24 16S15.163 42.667 8 32c7.163-10.667 15.163-16 24-16zm0 7a9 9 0 100 18 9 9 0 000-18zm0 5a4 4 0 110 8 4 4 0 010-8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
